var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-h6 text-sm-h5"},[_vm._v(" امروز: "+_vm._s(_vm.today)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }